import _ from "lodash";
import { InputSelector } from "../../../components/Forms/InputSelector";
import { IBaseFormProps } from "../../../components/interfaces";

const baseMediaFields = ["type", "thumbnail_src", "short_caption"];
const baseTypeFields = {
  video: ["video_file", "subtitle_file"],
  image: ["full_resolution_image"],
};

const imageHint = {
  video_node_media:
    "Must be a JPG or PNG file, 2500px on the longest edge @ 72dpi. Filenames must not have spaces or special characters",
  content_node_media:
    "Must be a JPG or PNG file, 2500px on the longest edge @ 72dpi. Filenames must not have spaces or special characters",
  profile_node_media:
    "Must be a JPG or PNG file, 2500px on the longest edge @ 72dpi. Filenames must not have spaces or special characters",
  attract_media_item:
    "Must be a JPG or PNG file, 2500px on the longest edge @ 72dpi. Filenames must not have spaces or special characters",
};

const videoHint = {
  attract_media_item:
    "Must be an optimised H264 MP4 file, H264, 960 x 640px. Filenames must not have spaces or special characters",
  video_node_media:
    "Must be an optimised H264 MP4 file, H264, 960 x 640px. Filenames must not have spaces or special characters",
  content_node_media:
    "Must be an optimised H264 MP4 file, H264, 960 x 640px. Filenames must not have spaces or special characters",
  profile_node_media:
    "Must be an optimised H264 MP4 file, H264, 960 x 640px. Filenames must not have spaces or special characters",
};

export const handleSchema = (type: string, model: string, schema: any) => {
  const addTypeFields =
    type in baseTypeFields
      ? baseTypeFields[type as keyof typeof baseTypeFields]
      : [];

  // const modelFields = type === "video" ? videoModelFields : imageModelFields;
  // const addModelFields =
  //   model in modelFields ? modelFields[model as keyof typeof modelFields] : [];

  const filters = [...baseMediaFields, ...addTypeFields];
  const filteredSchema = schema.filter((item: any) =>
    _.includes(filters, item.name)
  );

  const schemaWithHints = filteredSchema.map((item: any) => {
    if (item.name === "full_resolution_image" && model in imageHint) {
      return {
        ...item,
        overrideHint: imageHint[model as keyof typeof imageHint],
      };
    } else if (item.name === "video_file" && model in videoHint) {
      return {
        ...item,
        overrideHint: videoHint[model as keyof typeof videoHint],
      };
    }
    return item;
  });

  return schemaWithHints;
};

/**
 *
 * @param schema loaded schema
 * @param modelName name of model
 * @param itemData itemData state
 * @param setItemData setItemData state
 * @returns
 */
const MediaItemForm = ({
  schema,
  modelName,
  itemData,
  setItemData,
  customModel,
  onSubmit,
}: IBaseFormProps): JSX.Element => {
  const updateItemData = (keyname: string, value: any) => {
    if (_.has(itemData, keyname))
      setItemData({
        ...itemData,
        [keyname]: value,
      });
  };

  // Check media type to remove fields
  // const filters =
  //   itemData.type === "video"
  //     ? ["fullImageUrl"]
  //     : itemData.type === "image"
  //     ? ["videoUrl", "subtitleUrl"]
  //     : ["fullImageUrl", "videoUrl", "subtitleUrl", "thumbUrl"];

  // const filteredSchema = schema.filter(
  //   (item) => !_.includes(filters, item.name)
  // );

  const filteredSchema = handleSchema(
    itemData.type,
    customModel || modelName,
    schema
  );

  return (
    <form id="base-form" onSubmit={onSubmit}>
      <div className="flex flex-col gap-4">
        {filteredSchema.map((item: any, index: number) => (
          <InputSelector
            value={itemData[item.name]}
            key={index}
            onChange={(e) => {
              updateItemData(
                item.name,
                item.type === "number" ? e.target.valueAsNumber : e.target.value
              );
            }}
            overrideHint={item.overrideHint}
            modelname={modelName}
            customModel={customModel}
            {...item}
          />
        ))}
      </div>
    </form>
  );
};

export default MediaItemForm;
